var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "phone-settings" } }, [
    _c("div", { staticClass: "form-field" }, [
      _c(
        "label",
        { staticClass: "form-label", attrs: { for: "field-label" } },
        [_vm._v(_vm._s(_vm.$t("form.fieldLabel")))]
      ),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.item.phone.fieldPhone,
            expression: "item.phone.fieldPhone",
          },
        ],
        staticClass: "form-input",
        attrs: {
          type: "text",
          id: "field-label",
          placeholder: _vm.$t("message.phoneNumber"),
        },
        domProps: { value: _vm.item.phone.fieldPhone },
        on: {
          input: [
            function ($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(_vm.item.phone, "fieldPhone", $event.target.value)
            },
            function ($event) {
              return _vm.setFieldPhone(_vm.item.phone.fieldPhone)
            },
          ],
        },
      }),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "form-field" }, [
      _c("label", { staticClass: "form-label" }, [
        _vm._v(_vm._s(_vm.$t("form.labelAlignment"))),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "button-group" }, [
        _c(
          "button",
          {
            staticClass: "button",
            class: { active: _vm.align === "left" },
            on: {
              click: function ($event) {
                return _vm.setLabelAlign("left")
              },
            },
          },
          [_vm._v(_vm._s(_vm.$t("form.left")) + "\n            ")]
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "button",
            class: { active: _vm.align === "right" },
            on: {
              click: function ($event) {
                return _vm.setLabelAlign("right")
              },
            },
          },
          [_vm._v(_vm._s(_vm.$t("form.right")) + "\n            ")]
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "button",
            class: { active: _vm.align === "top" },
            on: {
              click: function ($event) {
                return _vm.setLabelAlign("top")
              },
            },
          },
          [_vm._v(_vm._s(_vm.$t("form.top")) + "\n            ")]
        ),
      ]),
      _vm._v(" "),
      _c("small", { staticClass: "form-description" }, [
        _vm._v(_vm._s(_vm.$t("form.chooseLabelAlignment"))),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "form-field" }, [
      _c("label", { staticClass: "form-label" }, [
        _vm._v(_vm._s(_vm.$t("form.required"))),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "toggle" }, [
        _c(
          "span",
          {
            staticClass: "toggle-option",
            class: { active: _vm.isRequired },
            on: { click: _vm.toggleRequired },
          },
          [_vm._v(_vm._s(_vm.requiredText))]
        ),
      ]),
      _vm._v(" "),
      _c("small", { staticClass: "form-description" }, [
        _vm._v(_vm._s(_vm.$t("form.fieldEmptyError"))),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "form-field" }, [
      _c("label", { staticClass: "form-label" }, [_vm._v("Görünürlük")]),
      _vm._v(" "),
      _c("div", { staticClass: "toggle" }, [
        _c(
          "span",
          {
            staticClass: "toggle-option",
            class: { active: _vm.visibility },
            on: { click: _vm.toggleVisibility },
          },
          [_vm._v(_vm._s(_vm.visibility ? "Görünür" : "Gizli"))]
        ),
      ]),
      _vm._v(" "),
      _c("small", { staticClass: "form-description" }, [
        _vm._v("Bu alanın form üzerinde görünür olup olmayacağını belirler"),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "form-field" }, [
      _c("label", { staticClass: "form-label", attrs: { for: "slug-input" } }, [
        _vm._v("URL Parametresi"),
      ]),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.slug,
            expression: "slug",
          },
        ],
        staticClass: "form-input",
        attrs: {
          type: "text",
          id: "slug-input",
          placeholder: "alan-slug-degeri",
        },
        domProps: { value: _vm.slug },
        on: {
          input: [
            function ($event) {
              if ($event.target.composing) {
                return
              }
              _vm.slug = $event.target.value
            },
            function ($event) {
              return _vm.setSlug($event.target.value)
            },
          ],
        },
      }),
      _vm._v(" "),
      _c("small", { staticClass: "form-description" }, [
        _vm._v("URL parametrelerinde kullanılacak benzersiz tanımlayıcı"),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "form-field" }, [
      _c("label", { staticClass: "form-label" }, [
        _vm._v(_vm._s(_vm.$t("form.subLabels"))),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "sub-labels" }, [
        _c("div", { staticClass: "sub-label-item" }, [
          _c("label", { staticClass: "sub-label", attrs: { for: "masked" } }, [
            _vm._v(_vm._s(_vm.$t("form.masked"))),
          ]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.item.phone.masked,
                expression: "item.phone.masked",
              },
            ],
            staticClass: "sub-label-input",
            attrs: {
              type: "text",
              id: "masked",
              placeholder: _vm.$t("form.validPhoneNumber"),
            },
            domProps: { value: _vm.item.phone.masked },
            on: {
              input: [
                function ($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.item.phone, "masked", $event.target.value)
                },
                function ($event) {
                  return _vm.setMasked(_vm.item.phone.masked)
                },
              ],
            },
          }),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }